import logger from 'src/utils/logger/logger';
export default function detection (agent) {
  let comp_agent = agent.indexOf("stbhuawei") != -1;
  if (comp_agent) {
    logger.info ("[stbhuawei detection] detected");
  }
  return comp_agent;
}



// WEBPACK FOOTER //
// ./src/devices/stbhuawei/detection.js